import moment from 'moment';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { downloadFile } from 'actions/common';

export const EXPORT_TO_EXCEL_REQUEST = 'EXPORT_TO_EXCEL_REQUEST';
export const EXPORT_TO_EXCEL_SUCCESS = 'EXPORT_TO_EXCEL_SUCCESS';
export const EXPORT_TO_EXCEL_FAILURE = 'EXPORT_TO_EXCEL_FAILURE';

function requestExportToExcel() {
  return {
    type: EXPORT_TO_EXCEL_REQUEST,
    isExportingToExcel: true
  };
}

function receiveExportToExcel(excelData) {
  return {
    type: EXPORT_TO_EXCEL_SUCCESS,
    isExportingToExcel: false,
    excelData,
    exportToExcelError: null
  };
}

function rejectExportToExcel(exportToExcelError) {
  return {
    type: EXPORT_TO_EXCEL_FAILURE,
    isExportingToExcel: false,
    exportToExcelError
  };
}

export function exportToExcel() {
  return (dispatch) => {
    dispatch(requestExportToExcel());

    const promise = () => ApiService
      .getExcelReporting({ responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receiveExportToExcel(response.data));
        return dispatch(
          downloadFile(
            response.data,
            `${ moment().format('DD_MMM_YYYY') }_report.xlsx`,
            'application/xls'
          )
        );
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectExportToExcel, true));
        }
      });
    return promise();
  };
}

export function getAllocationStatementFile(formId) {
  return (dispatch) => {
    dispatch(requestExportToExcel());

    const promise = () => ApiService
      .getAllocationStatementFile(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receiveExportToExcel(response.data));
        let fileName = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
        const firstChar = fileName.substring(0, 1);
        if (firstChar === '"') {
          fileName = fileName.slice(1, -1);
        }
        return dispatch(
          downloadFile(
            response.data,
            fileName,
            'application/octet-stream'
          )
        );
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectExportToExcel, true));
        }
      });
    return promise();
  };
}
